import React from "react";
import {
  IconNameEnum,
  useHotelsStyles,
  useModuleBEM,
} from "@b2bportal/core-themes";
import { CoreHotelsComponent } from "@b2bportal/core-types";
import { useI18nContext } from "@hopper-b2b/i18n";
import { Switch } from "@tenant/ui";
import clsx from "clsx";
import defaultStyles from "./FilterCancellation.module.scss";

export type FilterCancellationProps = {
  isFreeCancellationSelected: boolean;
  onChange: (isSelected: boolean) => void;
  className?: string;
};
export const FilterCancellation = ({
  isFreeCancellationSelected,
  onChange,
  className,
}: FilterCancellationProps) => {
  const styles = useHotelsStyles(
    CoreHotelsComponent.FilterCancellation,
    defaultStyles
  );
  const [block, cn] = useModuleBEM(
    styles,
    CoreHotelsComponent.FilterCancellation
  );
  const { t } = useI18nContext();

  return (
    <div className={clsx(className, block)}>
      <Switch
        id="freeCancellationFilter"
        className={cn("switch")}
        label={t(
          "core-hotels.availabilityPage.filters.cancellation.description"
        )}
        onChange={onChange}
        checked={isFreeCancellationSelected}
      />
    </div>
  );
};
